export const cerealesColor = {
  TRIGO: '#ffff00',
  SOJA: '#058a04',
  MAIZ: '#ff0012',
  CEBADAFO: '#7b3e02',
  CEBADACE: '#fde389',
  PELLETGC: '#000000',
  PELLETSJ: '#CCCCCC',
  HARISOJA: '#999999'
}

export const CEREALES = [
  'TRIGO',
  'SOJA',
  'MAIZ',
  'CEBADAFO',
  'CEBADACE',
  'PELLETGC',
  'PELLETSJ',
  'PELLETSC',
  'PELLETCG',
  'PELLETCS'
]

export const nombresCereales = {
  TRIGO: 'Trigo Pan',
  SOJA: 'Soja',
  MAIZ: 'Maiz',
  CEBADAFO: 'Cebada Forrajera',
  CEBADACE: 'Cebada Cervecera',
  PELLETGC: 'Pellet Girasol',
  PELLETSJ: 'Pellet Soja',
  PELLETSC: 'Pellet Comun',
  PELLETCG: 'Pellet Cascara de Girasol',
  PELLETCS: 'Pellet Cascara de Soja'
}

export const clavesCereales = {
  TrigoPan: 'TRIGO',
  Soja: 'SOJA',
  Maiz: 'MAIZ',
  CebadaForrajera: 'CEBADAFO',
  CebadaCervecera: 'CEBADACE',
  PelletGirasol: 'PELLETGC',
  PelletSoja: 'PELLETSJ',
  PelletComun: 'PELLETSC',
  PelletCascaraGirasol: 'PELLETCG',
  PelletCascaraSoja: 'PELLETCS'
}

export const cerealesVariedadColor = {
  ANDREIA: '#FBDA67',
  OVERTURE: '#F9D800',
  SHAKIRA: 'D0B75F',
  SCARLETT: '#958100',
  EXPLORER: '#SFFDF0',
  SCRABBLE: '#19FFE4',
  C74: '#FCAEFC',
  TRAVELLER: '#ES66ES',
  DANIELLE: 'FC8200',
  YANARA: '#FFFBDE',
  TRIGOPAN: '#FFFF00'
}

export const CerealesVariedad = [
  'SHAKIRA',
  'SCARLETT',
  'EXPLORER',
  'SCRABBLE',
  'ANDREIA',
  'C74',
  'TRAVELLER',
  'OVERTURE',
  'DANIELLE',
  'YANARA',
  'TRIGOPAN'
]

export const CebadaCerveceraVariedad = [
  'SHAKIRA',
  'SCARLETT',
  'EXPLORER',
  'SCRABBLE',
  'ANDREIA',
  'C74',
  'TRAVELLER',
  'OVERTURE',
  'DANIELLE',
  'MONTOYA',
  'ANDREFNB',
  'YANARA',
  'OVERTUG2'
]
